<template>
  <div>
    <div class="bg-white pb-5 d-flex flex-wrap justify-content-center">
      <div class="row mx-2 mx-md-4 d-flex flex-wrap justify-content-center">
        <div class="text-center fw-bold fs-2 py-5" data-cy="cases-list-header">مرضى الجمعيات</div>
        <div class="filters w-100 mb-4 px-3 px-md-0">
          <div class="row justify-content-start">
            <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-3">
              <span class="p-input-icon-right w-100">
                <i class="pi pi-search" />
                <InputText class="w-100" v-model="queryParams.charity_name" placeholder="ابحث حسب اسم الجمعية" @input="onSearchChanged($event.target.value)" />
              </span>
            </div>
            <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-3">
              <Dropdown v-model="queryParams.region" :options="state.regionOptions" optionLabel="name" optionValue="id"
                class="w-100" filter="true" placeholder="تصفية حسب المنطقة" id="region" @change="getCharityList()" />
            </div>
          </div>
        </div>
        <div v-if="loading" class="emp-cont">
          <BaseSpinner :size="4" class="py-5" />
        </div>
        <div v-else class="charity-card-board d-flex flex-wrap justify-content-center">
          <div class="charity-card-board__items" v-for="charity in charities" :key="index">
            <CharityCard class="charity-card-board__item" :charity="charity" />
          </div>
        </div>
        <div v-if="!charities.length && !loading" class="emp-cont">
          <div class="text-center bg-white fw-bold fs-2 py-5">لا يوجد الجمعيات</div>
        </div>
      </div>
    </div>

    <div class="row" v-if="charities?.length">
      <Paginator :rows="9" :totalRecords="totalItemsCount" @page="onPageChange($event)"></Paginator>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue';
import { debounce } from "@/helpers/helpers.ts";
import CharityCard from "./CharityCard.vue"
import BaseSpinner from "@/components/layout/BaseSpinner.vue";
import CharityService from "@/services/charity.service";
import EnumService from "@/services/enum.service";

const loading = ref(false)
let charities = reactive([])

const queryParams = {
  page: 1,
  page_size: 9,
  region: null,
  charity_name: null,
}

const state = reactive({
  regionOptions: [],
  loading: false,
  error: null,
});

const totalItemsCount = ref(9)

onMounted(() => {
  getRegionsOptions();
  getCharityList()
});
const getCharityList = () => {
  loading.value = true
  CharityService.getCharityList(queryParams)
    .then(({ data: { result } }) => {
      charities = result?.results
      totalItemsCount.value = result?.total_objects;
    }).finally(() => {
      loading.value = false
    })
}
const onPageChange = (event) => {
  queryParams.page = event.page + 1;
  getCharityList()
};
const onSearchChanged = debounce((value) => {
  queryParams.charity_name = value;
  getCharityList();
});

const getRegionsOptions = async () => {
  try {
    state.loading = true;
    const { data } = await EnumService.regions();
    state.regionOptions = data.result;
  } catch (error) {
    state.error = error;
  } finally {
    state.loading = false;
  }
};

</script>

<style lang="scss" scoped>
@import "@/styles/abstracts/mixins";
@import "@/styles/components/_table-filter.scss";

.charity-card-board {
  &__items {
    max-width: 1125px;
  }

  &__item {
    flex: 0 0 calc(33% - 50px);
    min-width: 300px;
    max-width: 310px;
    margin-right: 25px;
    margin-left: 25px;
    margin-bottom: 30px !important;
  }

  max-width: 1125px !important;

  @include respond('xl') {
      &__items {
        margin: 0;
      }
      &__item {
        flex: 0 0 calc(38% - 20px);
      }
    }
  @include respond('lg') {
    &__item {
      flex: 0 0 calc(45% - 20px);
    }
  }

  @include respond('md') {
    &__item {
      flex: 0 0 calc(90% - 20px);
      margin-left: 0;
      margin-right: 0;
    }
  }
}
.filters {
  max-width: 1050px;
  width: 100%;
}

@media (max-width: 1130px) {
  .filters {
    justify-content: center;
  }
}

::v-deep(.p-paginator) {

  .p-paginator-first,
  .p-paginator-prev,
  .p-paginator-next,
  .p-paginator-last {
    transform: rotate(180deg);
  }
}
::v-deep(.p-input-icon-right) {
  width: 100%;
  display: block;
}

.emp-cont {
  max-width: 1125px;
  width: 100%;
}
</style>